window.apisExactStatusLogDetailFormatter = function(value, row) {
    let html = '';
    if (row.reason) {
        html += '<div class="form-group">';
        html += "<label>"+__("Reason") + "</label>";
        html += '<textarea class="form-control" rows="3">'+row.reason+"</textarea>";
        html += "</div>";
    }
    return html;
};

